<template>
  <div class="player-mobile">

    <!-- User message before playing -->
    <template v-if="!countryDataAvailable">
      <div class="user-message is-overlay">
        <b-tag rounded
               type="is-info"
        >{{userMessageBeforePlaying}}</b-tag>
      </div>
    </template>

    <!-- Play/pause/stop and labels -->
    <nav class="level is-mobile">

      <!-- Play/Pause and Stop -->
      <div class="level-left">
        <div class="level-item">
          <b-button icon-right="play"
                    @click="play"
                    :disabled="!countryDataAvailable || isPlaying"
                    rounded/>
        </div>
        <div class="level-item">
          <b-button icon-right="stop"
                    @click="stop"
                    :disabled="!countryDataAvailable || !isPlaying"
                    rounded />
        </div>
      </div>

      <!-- Current position -->
      <div class="level-right">
        <div class="level-item">
          <b-button type="is-dark"
                    @click="openRangeSelector"
                    class="current-date"
                    rounded
                    outlined
                    inverted
                    expanded
                    :disabled="!countryDataAvailable">
            {{countryDataAvailable ? formatDataRangeLabel(currentDataIndex) : noIndex}}
          </b-button>
        </div>
      </div>
    </nav>

    <!-- Seek control -->
    <b-slider rounded
              size="is-small"
              :min="countryDataAvailable ? dataRange[0] : 0"
              :max="countryDataAvailable ? dataRange[1] : 0"
              v-model="currentDataIndex"
              :disabled="!countryDataAvailable"
              :tooltip="false"
              bigger-slider-focus
              lazy/>

    <!-- Range selection modal -->
    <b-modal :active.sync="isRangeSelectionModalActive"
                  has-modal-card
                  trap-focus
                  aria-role="dialog"
                  aria-modal>
      <ModalWrapper title="Select a data range">
        <RangeSelector />
      </ModalWrapper>
    </b-modal>

  </div>
</template>

<script>
import RangeSelector from '@/components/controls/RangeSelector.vue';
import ModalWrapper from './ModalWrapper.vue';
import actions from '../../store/actions';

export default {
  name: 'PlayerMobile',
  components: {
    ModalWrapper,
    RangeSelector,
  },
  data() {
    return {
      userMessageBeforePlaying: 'Please select a location on the globe and turn up the volume!',
      isRangeSelectionModalActive: false,
      // Harcoded, whatever
      noIndex: 'Wed Jan 22 2020',
    };
  },
  computed: {
    isPlaying() {
      return this.$store.state.playing;
    },
    country() {
      return this.$store.state.country;
    },
    currentDataIndex: {
      get() {
        return this.$store.state.currentDataIndex || 0;
      },
      set(index) {
        this.$store.dispatch(actions.CHANGE_CURRENT_DATA_INDEX, index);
      },
    },
    countryDataAvailable() {
      return this.country.length > 0;
    },
    dataRange() {
      return this.$store.state.dataRange;
    },
  },
  methods: {
    play() {
      this.$store.dispatch(actions.PLAY);
    },
    stop() {
      this.$store.dispatch(actions.STOP);
    },
    formatDataRangeLabel(idx) {
      return this.countryDataAvailable
        ? new Date(this.country[idx].day).toDateString()
        : '';
    },
    openRangeSelector() {
      this.isRangeSelectionModalActive = true;
    },
  },
};
</script>

<style scoped>
.player-mobile {
  position: fixed;
  padding: 5%;
  width: 100%;
  bottom: 0;
}

.user-message {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  backdrop-filter: brightness(40%) blur(1px);
}

.current-date {
  font-variant-numeric: tabular-nums;
  font-family: monospace;
}
</style>
